// Replace document.title with a flashing OTP indicator.
// Browser tab strip becomes the OTP itself — operator never has to switch tabs.

let original: string | null = null;
let timer: number | null = null;

export function startTitleFlash(otpCode: string) {
  if (timer) stopTitleFlash();
  original = document.title;
  const flashed = `🔴 ${otpCode} — OTP READY`;
  let on = true;
  document.title = flashed;
  timer = window.setInterval(() => {
    on = !on;
    document.title = on ? flashed : original ?? 'Trawish · Payment ops';
  }, 2000);
}

export function stopTitleFlash() {
  if (timer) window.clearInterval(timer);
  timer = null;
  if (original) document.title = original;
  original = null;
}
